import React, { useState } from "react";
import { apiRequestFile } from "../utils/api"; // apiRequestFileのインポート
import { apiRequest } from "../utils/api"; // apiRequestのインポート
import "../styles/UploadExcel.css";

const UploadExcel = () => {
  const [file, setFile] = useState(null);
  const [uploadedData, setUploadedData] = useState(null);
  const [duplicateSkus, setDuplicateSkus] = useState([]);
  const [hasDuplicates, setHasDuplicates] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage("ファイルを選択してください");
      return;
    }

    setIsLoading(true);

    try {
      const response = await apiRequestFile('inventory/upload_excel/', 'POST', file);

      const { uploaded_data, duplicate_skus, has_duplicates } = response;

      setUploadedData(uploaded_data);
      setDuplicateSkus(duplicate_skus);
      setHasDuplicates(has_duplicates);

      setMessage("ファイルがアップロードされました");
    } catch (error) {
      setMessage("ファイルアップロード中にエラーが発生しました");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveData = async () => {
    try {
      await apiRequest('inventory/save_data/', 'POST');
      setMessage("データが保存されました");
      setUploadedData(null);
      setDuplicateSkus([]);
      setHasDuplicates(false);
    } catch (error) {
      setMessage("データ保存中にエラーが発生しました");
    }
  };

  const handleClearSession = async () => {
    try {
      await apiRequest('inventory/clear_session/', 'POST');
      setUploadedData(null);
      setDuplicateSkus([]);
      setHasDuplicates(false);
      setMessage("セッションがクリアされました");
    } catch (error) {
      setMessage("セッション削除中にエラーが発生しました");
    }
  };

  return (
    <div className="upload-container">
      <h1>Excel一括登録</h1>
      <form onSubmit={handleSubmit}>
        <input type="file" onChange={handleFileChange} />
        <button type="submit" disabled={isLoading}>アップロード＆プレビュー</button>
      </form>
      <div className="center"><p>{message}</p></div>

      {isLoading && <p>アップロード中...</p>}

      {duplicateSkus.length > 0 && (
        <div>
          <strong>【警告】以下のSKUが重複しています</strong>
          <ul>
            {duplicateSkus.map((sku, index) => (
              <li key={index}>SKU: {sku.sku} (商品名: {sku.item_name})</li>
            ))}
          </ul>
        </div>
      )}

      {uploadedData && (
        <div>
          <div className="preview-table-container">
            <table>
              <thead>
                <tr>
                  <th>Item Name</th>
                  <th>SKU</th>
                  <th>Manufacturer</th>
                  <th>Title</th>
                  <th>Genre1</th>
                  <th>Genre2</th>
                  <th>JAN</th>
                  <th>Release Date</th>
                  <th>Category</th>
                </tr>
              </thead>
              <tbody>
                {uploadedData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.item_name}</td>
                    <td>{row.sku}</td>
                    <td>{row.manufacturer}</td>
                    <td>{row.title}</td>
                    <td>{row.genre1}</td>
                    <td>{row.genre2}</td>
                    <td>{row.jan}</td>
                    <td>{row.release_date}</td>
                    <td>{row.category}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="fixed-action">
            {hasDuplicates ? (
              <>
                <p>重複する SKU がデータベースに存在します。削除してください。</p>
                <button onClick={handleClearSession}>アップロードデータを削除</button>
              </>
            ) : (
              <>
                <p>ファイルが正しく読み込まれました。データを保存してください。</p>
                <button onClick={handleSaveData}>商品データ一括登録</button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadExcel;
